﻿import { GroCommon } from '../common.js';
import { setDropdown } from '../form-controls.js';
import { formDisableSubmitOnEnter } from '../../../es6/helpers/Forms.js';
/**
 * @description PurchasingAgreementForm
 *
 * @param {string} formSelector Selector (jQuery) for form
 * @param {PurchasingAgreementService} purchasingAgreementService Purchasing agreement service instance
 * @param {PurchasingAgreementStepsComponent} stepsComponent Steps component instance
 * @param {boolean} isInternalPage Flag for LM2 internal
 * @param {string} agreementType Agreement type
 * @param {string} priceAreaId Price Area Id
 *
 **/
export const PurchasingAgreementForm = function (
  formSelector,
  purchasingAgreementService,
  stepsComponent,
  isInternalPage,
  agreementType,
  priceAreaId,
) {
  var $form = $(formSelector);
  var $btnSubmit = $('.btnSaveAgreement');
  var $btnBackToReceiverForm = $('.btnBackToReceiverForm');
  var $btnBackToAgreementForm = $form.find('.btnBackToAgreementForm');
  var $btnReview = $form.find('.btnToReview');
  var $btnGotoReceiverForm = $form.find('.btnGotoReceiverForm');
  var $dropdownProducts = $form.find('.productDropdown');
  var $dropdownGrainType = $form.find('.grainTypeDropdown');
  var $dropdownWarehouses = $form.find('.warehouseDropdown');
  var $dropdownPeriod = $form.find('.periodDropdown');
  var $dropdownAgreement = $form.find('.avtalDropdown');
  var $dropdownSeedAgreement = $form.find('.seedAvtalDropdown');

  const $getFixedPriceAgreementCategories = $form.find('.getFixedPriceAgreementCategories');
  const $getFixedPriceAgreementGroup = $form.find('.getFixedPriceAgreementGroup');
  const $getFixedPriceAgreementItem = $form.find('.getFixedPriceAgreementItem');
  const $btnAddItemToLocalStorage = $form.find('#btnAddItem');

  var $dropdownAgreementType = $form.find('.avtalsTypDropdown');
  var $radioWatchType = $form.find('input[name="WatchType"]');
  var $checkboxTermsAccepted = $form.find('#approveAgreementTerm');
  var $checkboxCreateReserveAgreement = $form.find('#CreateReserveAgreement');
  var $dropdownReceivers = $form.find('.receiverDropdown');
  var $quantity = $('#CommitQuantity');

  // Product area id's
  const PIGGFOR = '411';
  const PULLFOR = '412';
  const NOTFOR = '410';
  const VALIDCATEGORIES = [PIGGFOR, PULLFOR, NOTFOR];

  // Helper class from es6 project
  formDisableSubmitOnEnter(formSelector);

  /**
   * @description Only allow integers on input number fields.
   * Parse input as user type. Remove floating points.
   * @returns void
   */
  const intRx = /\d/,
    integerChange = (event) => {
      if (
        event?.key?.length > 1 ||
        event.ctrlKey ||
        (event.key === '-' && !event.currentTarget.value.length) ||
        intRx.test(event.key)
      ) {
        if (/[^0-9]+/.test(event.currentTarget.value)) {
          event.currentTarget.value = event.currentTarget.value.replace(/[^0-9]*/g, '');
          return;
        }
      }
    };

  var callbacks = {
    save: [],
  };

  let globalArticleNumber;
  const ELM_DEFAULT_PRICE = 'defaultPrice';
  let specialAppliedRulesForPigPull = false;

  /**
   * @description Combox Loader
   * showing and animated line on selectbox bottom when loading
   * @returns void
   * */
  const comboBoxLoader = {
    /**
     * Loader for Combo box - Add loaders to markup
     * @param {any} event
     */
    initBottomLinearLoader: (event) => {
      let element = document.querySelectorAll('div[class$="init-bottom-linear-loader"]');

      element.forEach(function (item) {
        var div = document.createElement('div');
        div.className = 'bottom-linear-loader hidden';
        item.appendChild(div);
      });
    },

    /**
     * @description Trigger event on field change
     * @param {*} element
     * @param {*} elementState
     * @returns void
     */
    triggerLoader: (element, elementState) => {
      !elementState
        ? element.nextElementSibling.classList.add('hidden')
        : element.nextElementSibling.classList.remove('hidden');
    },
  };

  /**
   * @description Fixed Price Agreement form logic
   * Handle logic for Form interaction
   * @returns void
   */
  const fixedPriceAgreement = {
    /**
     * @description Init Fixed Agreement
     * @returns void
     */
    init: () => {
      if (agreementType !== 'FastPrisAvtalFoder') return false;

      // Remove storage
      fixedPriceAgreement.articleItems.removeStorage();

      // Set event triggers
      document
        .getElementById('fixedPricebtnGotoReceiverForm')
        .addEventListener('click', fixedPriceAgreement.articleItems.review);

      document
        .getElementById('fixedPriceAgreementFromDate')
        .addEventListener('change', fixedPriceAgreement.preValidation);

      document
        .getElementById('fixedPriceAgreementToDate')
        .addEventListener('change', fixedPriceAgreement.preValidation);

      document
        .getElementById('ProductAreaItemId')
        .addEventListener('change', fixedPriceAgreement.preValidation);

      document
        .getElementById('CallOffAgreementNr')
        .addEventListener('input', fixedPriceAgreement.disableContinueButton);

      // Additional text fields
      fixedPriceAgreement.articleItems.additionalTexts();

      // Disable form submit on enter
      fixedPriceAgreement.disableFormSubmitOnEnter();
    },

    /**
     * @description Lock fixedPrice submit button if value is not valid.
     * and Change all not capital letters uppercase
     */
    disableContinueButton: (evt) => {
      const validationRegExp = /^FP\d{4}$/;
      const submitButton = document.getElementById('fixedPricebtnGotoReceiverForm');
      const errorSpan = document.getElementById('CallOffAgreementNrErrorText');
      const callOff = evt.target.value.toUpperCase();

      if (validationRegExp.test(callOff)) {
        purchasingAgreementService
          .checkIfFixedPriceAgreementExists(callOff)
          .done(function (data) {
            if (data) {
              submitButton.setAttribute('disabled', 'true');
              errorSpan.textContent = evt.target.getAttribute('data-already-exists');
            } else {
              submitButton.removeAttribute('disabled');
              errorSpan.textContent = '';
            }
          })
          .fail(function () {
            submitButton.setAttribute('disabled', 'true');
            errorSpan.textContent = evt.target.getAttribute('data-generic-error');
          });
      } else {
        submitButton.setAttribute('disabled', 'true');
        errorSpan.textContent = evt.target.getAttribute('data-original-title');
      }
    },

    /**
     * @description Disable form submit on enter (Chrome doesn't seem to listen to key 13.)
     * You should not be able to submit the form by pressing enter -_-
     * @returns {boolean}
     */
    disableFormSubmitOnEnter: () => {
      document.querySelector('#PurchasingAgreementForm').addEventListener('keydown', (e) => {
        if (e.key === 13 || e.key === 'Enter') {
          e.preventDefault();
          return false;
        }
      });
    },

    /**
     * @description Date input based on Product category
     * @param {*} category
     * @returns void
     */
    productCategoryChanges: (category) => {
      if (document.getElementsByClassName('fixedPriceAgreementForm').length < 1) {
        return;
      }

      if (VALIDCATEGORIES.includes(category.data)) {
        document.querySelector('.product-group-date-style-picker').classList.remove('hidden');
        document.querySelector('.product-group-date-style-combo').classList.add('hidden');
      } else {
        document.querySelector('.product-group-date-style-picker').classList.add('hidden');
        document.querySelector('.product-group-date-style-combo').classList.remove('hidden');
      }

      specialAppliedRulesForPigPull = VALIDCATEGORIES.slice(0, -1).includes(category.data);
      fixedPriceAgreement.resetFields();
    },

    /**
     * @description Reset fields
     */
    resetFields: () => {
      document.querySelector('#CommitQuantity').value = '';
      document.querySelector('#defaultPrice').value = '';
      document.querySelector('#termSupplement').value = '';
      document.querySelector('#manualDiscount').value = '';
      document.querySelector('#getFixedPriceAgreementItem .dropdown').innerHTML = '';
      document.querySelector('#getFixedPriceAgreementItem a').innerText = '';
    },

    /**
     * @description Fixed price Agreement Foder - On categories change load data for groups.
     * Set max length on manual discount
     * @param {any} event
     * @param {any} selectedItem
     * @returns {Object}
     */
    onFixedPriceAgreementCategoryChange: (event, selectedItem) => {
      comboBoxLoader.triggerLoader(event.target, true);

      // Set max quantity on field
      fixedPriceAgreement.setMaxValueOnCategorySelect(
        event.target.getAttribute('data-maxquantity'),
        $.map(selectedItem, function (item, i) {
          return item;
        }),
      );

      // Change date input type.
      fixedPriceAgreement.productCategoryChanges(selectedItem);
      document.querySelector('.fix-article-group .spin-component').classList.remove('hidden');
      purchasingAgreementService.getFixedPriceAgreementGroups(selectedItem).done(function (data) {
        const options = $.map(data, function (item, i) {
          return { value: item.ProductGroupId, display: item.ProductGroupName };
        });

        renderDropdown($getFixedPriceAgreementGroup, options, 'Välj sort');
        comboBoxLoader.triggerLoader(event.target, false);
        document.querySelector('.fix-article-group .spin-component').classList.add('hidden');
      });
    },

    /**
     * @description Fixed price Agreement Foder - On groups change load data for item.
     * @param {any} event
     * @param {any} selectedItem
     * @returns {Object}
     */
    onFixedPriceAgreementGroupChange: (event, selectedItem) => {
      comboBoxLoader.triggerLoader(event.target, true);
      document.querySelector('.fix-article .spin-component').classList.remove('hidden');
      purchasingAgreementService.getFixedPriceAgreementItems(selectedItem).done(function (data) {
        const options = $.map(data, function (item, i) {
          return { value: item.ItemNumber, display: item.ItemName };
        });

        renderDropdown($getFixedPriceAgreementItem, options, 'Välj sort');
        comboBoxLoader.triggerLoader(event.target, false);
        fixedPriceAgreement.preValidation();
        document.querySelector('.fix-article .spin-component').classList.add('hidden');
      });
    },

    /**
     * @description Fixed price agreement - article base price
     * Get Base price from back end
     * @param {any} event
     * @param {any} selectedItem
     * @returns void
     */
    onFixedPriceAgreementArticleChange: (event, selectedItem) => {
      const customerNumber = document.getElementById('customerNumberElementId').value;
      document.querySelector('.fix-def-price .spin-component').classList.remove('hidden');

      // Service call to get base price
      purchasingAgreementService
        .getFixedPriceAgreementBasePrice(selectedItem.data, customerNumber)
        .done((data) => {
          document.getElementById('manualDiscount').value = '';
          // Round to 2 decimals
          document.getElementById(ELM_DEFAULT_PRICE).value = parseFloat(data).toFixed(2);
          fixedPriceAgreement.preValidation();
          fixedPriceAgreement.calculateCustomPrice();
          document.querySelector('.fix-def-price .spin-component').classList.add('hidden');
        });
    },

    /**
     * @description Validate fields before user is able to add item
     * Checking the combinations
     * @returns void || boolean
     */
    preValidation: () => {
      if (agreementType !== 'FastPrisAvtalFoder') return false;

      const validKeysMinMax = ['manualDiscount', 'CommitQuantity', 'termSupplement'];

      if (
        document.getElementById('articleGroup').value.length > 0 &&
        document.getElementById('article').value.length > 0
      ) {
        document.getElementById('manualDiscount').classList.remove('disabled');
      } else {
        document.getElementById('manualDiscount').classList.add('disabled');
      }

      if (!specialAppliedRulesForPigPull) {
        for (let item of validKeysMinMax) {
          if (
            !validateInputFromSelector(document.querySelector(`#${item}`)) &&
            document.querySelector(`#${item}`).hasAttribute('min') &&
            document.querySelector(`#${item}`).hasAttribute('max')
          ) {
            document.getElementById('btnAddItem').classList.add('disabled');
            return false;
          }
        }
      }

      // Check what kind of field type...
      const toDate = document
        .querySelector('.product-group-date-style-picker')
        .classList.contains('hidden')
        ? 'fixedPriceAgreementToDate'
        : 'fixedPriceAgreementToDatePicker';

      if (
        document.getElementById('CommitQuantity').value.length == 0 ||
        document.getElementById('fixedPriceAgreementFromDate').value.length == 0 ||
        document.getElementById(toDate).value.length == 0 ||
        document.getElementById('defaultPrice').value.length == 0
      ) {
        document.getElementById('btnAddItem').classList.add('disabled');
        return false;
      }

      document.getElementById('btnAddItem').classList.remove('disabled');
      return true;
    },

    /**
     * @description Set Max value on manual discount element when selecting Category
     * @param {any} maxDiscountObj
     * @param {any} selectedvalue
     * @returns void
     */
    setMaxValueOnCategorySelect: (maxDiscountObj, selectedItem) => {
      document.getElementById('manualDiscount').removeAttribute('max');
      const maxDiscount = Object.entries(JSON.parse(maxDiscountObj));

      for (let i = 0; i < maxDiscount.length; i++) {
        if (maxDiscount[i][1]['name'] === selectedItem[1]) {
          document.getElementById('manualDiscount').setAttribute('max', maxDiscount[i][1]['value']);
        }
      }

      document.getElementById('manualDiscount').setAttribute('min', '0');
    },

    /**
     * @description Calculate custom price, manual discount and term supplement
     * @returns void
     */
    calculateCustomPrice: () => {
      const customerPrice = document.querySelector('#customerPrice');
      const manualDiscount = document.querySelector('#manualDiscount');
      const termSupplement = document.querySelector('#termSupplement');
      const defaultPrice = document.querySelector('#defaultPrice');

      /**
       * @description Calculate Manual discount when changing Customer Price
       * Lock Term Supplement and Manual Discount When chaning Customer Price
       */
      customerPrice.addEventListener('change', (evt) => {
        fixedPriceAgreement.setDiscountOnCustomerPriceChange(
          evt,
          termSupplement,
          manualDiscount,
          defaultPrice,
        );
      });

      /**
       * @description Calculate manual discount
       * Lock Customer Price and set customer price when chaning Manual Discount
       */
      manualDiscount.addEventListener('change', (evt) => {
        fixedPriceAgreement.setCustomerPriceOnManualDiscountChange(
          evt,
          termSupplement,
          customerPrice,
          manualDiscount,
          defaultPrice,
        );
      });

      /**
       * @description Calculate term supplement
       * Lock Customer Price and set customer price when chaning Term Supplement
       */
      termSupplement.addEventListener('change', (evt) => {
        fixedPriceAgreement.setCustomerPriceOnTermSupplementChange(
          evt,
          customerPrice,
          manualDiscount,
          defaultPrice,
          termSupplement,
        );
      });
    },

    /**
     * @description Calculate and set manual discount when changing Customer Price
     * Lock Term Supplement and Manual Discount When chaning Customer Price
     * @param {*} evt
     * @param {*} termSupplement
     * @param {*} manualDiscount
     * @param {*} defaultPrice
     * @returns void
     */
    setDiscountOnCustomerPriceChange: (evt, termSupplement, manualDiscount, defaultPrice) => {
      manualDiscount.value = '';
      termSupplement.value = '';

      // Reseting validation
      var form = $('#PurchasingAgreementForm'),
        validator = form.validate();
      validator.resetForm();
      form.find('.error').removeClass('error');

      const input = Math.abs(evt.target.value);

      if (evt.target.value !== '') {
        termSupplement.value = '';
        manualDiscount.value = '';
        termSupplement.setAttribute('disabled', 'disabled');
        manualDiscount.setAttribute('disabled', 'disabled');
      } else {
        termSupplement.removeAttribute('disabled');
        manualDiscount.removeAttribute('disabled');
      }

      let newDiscount = parseFloat(input) - parseFloat(defaultPrice.value);
      const discountValue = Math.trunc(parseFloat(newDiscount).toFixed(2) * 100);

      if (newDiscount > 0) {
        termSupplement.value = discountValue;
      } else {
        manualDiscount.value = Math.abs(discountValue);
      }

      validatePriceAdjustmentFields(manualDiscount, termSupplement);

      if (isNaN(parseInt(input)) || input === 0) {
        manualDiscount.value = '';
        termSupplement.value = '';
        return;
      }
    },

    /**
     * @description Calculate manual discount
     * Lock Customer Price when chaning Manual Discount
     * @param {*} evt
     * @param {*} termSupplement
     * @param {*} customerPrice
     * @param {*} manualDiscount
     * @param {*} defaultPrice
     * @returns void
     */
    setCustomerPriceOnManualDiscountChange: (
      evt,
      termSupplement,
      customerPrice,
      manualDiscount,
      defaultPrice,
    ) => {
      const input = evt.target.value;
      const termsup = termSupplement.value ? parseInt(termSupplement.value) / 100 : 0;

      if (termSupplement.value !== '' || manualDiscount.value !== '') {
        customerPrice.setAttribute('disabled', 'disabled');
      } else {
        customerPrice.removeAttribute('disabled');
      }

      let newPrice;
      if (isNaN(parseInt(input))) {
        newPrice = termsup
          ? parseFloat(defaultPrice.value) + termsup
          : parseFloat(defaultPrice.value);
        customerPrice.value = termsup ? parseFloat(newPrice).toFixed(2) : newPrice.toFixed(2);
      } else {
        newPrice = defaultPrice.value - parseFloat(input) / 100 + termsup;
        customerPrice.value = newPrice.toFixed(2);
      }
    },

    /**
     * @description Calculate term supplement
     * Lock Customer Price when chaning Term Supplement
     * @param {*} evt
     * @param {*} customerPrice
     * @param {*} manualDiscount
     * @param {*} defaultPrice
     * @param {*} termSupplement
     * @returns void
     */
    setCustomerPriceOnTermSupplementChange: (
      evt,
      customerPrice,
      manualDiscount,
      defaultPrice,
      termSupplement,
    ) => {
      const input = evt.target.value;
      const manualDisc = manualDiscount.value ? parseInt(manualDiscount.value) / 100 : 0;

      let newPrice;
      if (termSupplement.value !== '' || manualDiscount.value !== '') {
        customerPrice.setAttribute('disabled', 'disabled');
      } else {
        customerPrice.removeAttribute('disabled');
      }

      newPrice = 0;

      // Check if input is not empty
      if (isNaN(parseInt(input))) {
        newPrice = manualDisc
          ? parseInt(defaultPrice.value) - manualDisc
          : parseFloat(defaultPrice.value);
        customerPrice.value = manualDisc ? parseFloat(newPrice).toFixed(2) : newPrice;
      } else {
        // Check if input is positive or negative
        if (parseInt(input) > 0) {
          newPrice = parseFloat(defaultPrice.value) + parseFloat(Math.abs(input)) / 100;
        } else {
          newPrice = parseFloat(defaultPrice.value) - parseFloat(Math.abs(input)) / 100;
        }

        // Reduct manual discount if it is set
        if (manualDisc) {
          newPrice = newPrice - parseFloat(Math.abs(manualDisc));
        }

        // Set new price
        customerPrice.value = parseFloat(newPrice).toFixed(2);
      }
    },

    /**
     * @description ArticleItems Object handles the Articles.
     * */
    articleItems: {
      /**
       * @description Remove Local storage
       * @returns void
       */
      removeStorage: () => {
        localStorage.removeItem('fixedPriceAgreement');
      },

      /**
       * @description Get Items
       * @returns {Object}
       */
      getItem: () => {
        return localStorage.getItem('fixedPriceAgreement');
      },

      /**
       * @description CollectData from fields
       * @returns {Map}
       * */
      collectFormData: () => {
        const formData = new Map();
        const fieldKeys = [
          'customerPrice',
          'manualDiscount',
          'termSupplement',
          'defaultPrice',
          'CommitQuantity',
          'article',
        ];

        fieldKeys.map((fieldId, index) => {
          if (fieldKeys.includes(fieldId)) {
            if (fieldId === 'article') {
              formData.set(
                'articleName',
                document
                  .getElementsByClassName('getFixedPriceAgreementItem')[0]
                  .getAttribute('data-designation'),
              );
              formData.set('articleNr', document.getElementById(fieldId).value);
            } else {
              formData.set(fieldId, document.getElementById(fieldId).value);
            }
          }
        });

        return formData;
      },

      /**
       * @description Add item to storage - call collectDataFromFields to handle data
       * Add Items to agreement table
       * @returns void
       * */
      addItem: () => {
        const agreementData = fixedPriceAgreement.articleItems.collectFormData();
        const agreementTable = document
          .getElementById('myfixedPriceAgreements')
          .getElementsByTagName('tbody')[0];

        if (!fixedPriceAgreement.preValidation()) {
          return false;
        }

        const tableRow = agreementTable.insertRow(0);

        // Store item to
        const storage = fixedPriceAgreement.articleItems.storeData(agreementData);

        // Populate table rows with data and lock fields
        if (storage) {
          fixedPriceAgreement.articleItems.populateTable({
            data: agreementData,
            table: tableRow,
          });
          fixedPriceAgreement.articleItems.fieldLock(true);
          fixedPriceAgreement.articleItems.changeFields({}, false);
          // Clone items and create formelements for review
          fixedPriceAgreement.articleItems.review();
        }

        document.getElementById('fixedPricebtnGotoReceiverForm').classList.remove('hidden');

        document.querySelector('.additionalTexts').classList.remove('hidden');
      },

      /**
       * @description Lock fields if article is selected
       * @param {boolean} selectedArticle
       * @returns void
       */
      fieldLock: (selectedArticle) => {
        const listElements = document.getElementsByClassName('lockable');

        for (let int = 0; int < listElements.length; int++) {
          selectedArticle
            ? listElements[int].classList.add('disabled')
            : listElements[int].classList.remove('disabled');
        }
      },

      /**
       * @description Store data to Local storage
       * @param {object} agreementData
       * @returns {boolean}
       */
      storeData: (agreementData) => {
        let storedData = [];
        storedData = JSON.parse(fixedPriceAgreement.articleItems.getItem()) || [];

        // Check if item is already saved in storage.
        for (let item of storedData) {
          if (item.articleNr === Object.fromEntries(agreementData).articleNr) {
            return false;
          }
        }

        storedData.push(Object.fromEntries(agreementData));
        localStorage.setItem('fixedPriceAgreement', JSON.stringify(storedData));
        return true;
      },

      /**
       * @description Clean and format input
       * @param {*} str
       * @param {string} strType
       * @returns string
       */
      parseAdditionalInput: (strType, str) => {
        if (strType === 'designation') {
          return str
            .slice(0, 30)
            .toLowerCase()
            .replace(/[^a-zåäöA-ZÅÄÖ0-9  *]+/g, '-');
        }

        if (strType === 'callOff') {
          return str
            .slice(0, 7)
            .toUpperCase()
            .replace(/[^a-zA-Z0-9]+/g, '');
        }
      },

      /**
       * @description Populate Table with form data
       * @param {any} params
       * @returns void
       */
      populateTable: (params) => {
        // showing item list
        document.getElementById('fpa-agreement-basket').classList.remove('hidden');
        let articleNr;

        // Getting the Article number
        for (let [key, value] of params.data.entries()) {
          if (key === 'articleNr') {
            articleNr = value;
          }
        }

        // Creating Table cells with form data
        for (let [key, value] of params.data.entries()) {
          let agreementCell = params.table.insertCell(0);

          if (key === 'articleNr') {
            params.table.setAttribute('id', `item_${value}`);
            agreementCell.setAttribute('data-item-id', value);
            articleNr = value;
          }

          agreementCell.setAttribute('id', `item_${articleNr}_${key}`);

          if (key === 'articleName' && document.querySelector('#Designation').value === '') {
            let parsedDesignationValue = fixedPriceAgreement.articleItems.parseAdditionalInput(
              'designation',
              value,
            );

            document.querySelector('#Designation').setAttribute('value', parsedDesignationValue);

            document.querySelector('#reviewDesignation').innerText = parsedDesignationValue;
          }

          if (key !== 'articleName') {
            agreementCell.classList.add(key, 'center-text');
          }

          agreementCell.innerHTML = value.replace('.', ',');
        }

        // Adding icons for editing and deleting
        fixedPriceAgreement.articleItems.listTools({
          articleNr: articleNr,
          tableRow: params.table,
        });
      },

      /**
       * @descriptrion Additional text fields
       * Created when selecting aricle
       * Replaces generated Agreement id & Agreement name
       * @returns void
       */
      additionalTexts: () => {
        const additionalFields = [
          {
            id: '#CallOffAgreementNr',
            reviewId: '#reviewCallOffAgreementNr',
            containerClass: '.reviewAdditionalTextCalloff',
            parseType: 'callOff',
          },
          {
            id: '#Designation',
            reviewId: '#reviewDesignation',
            containerClass: '.reviewAdditionalTextDesignation',
            parseType: 'designation',
          },
        ];

        for (let additional of additionalFields) {
          document.querySelector(additional.id).addEventListener(
            'change',
            (evt) => {
              if (evt.target.value) {
                document.querySelector(additional.reviewId).innerText =
                  fixedPriceAgreement.articleItems.parseAdditionalInput(
                    additional.parseType,
                    evt.target.value,
                  );
                document.querySelector(additional.containerClass).classList.remove('hidden');
              } else {
                document.querySelector(additional.containerClass).classList.add('hidden');
                evt.innerText = '';
              }

              // Parse and format text string
              document.querySelector(additional.id).value =
                fixedPriceAgreement.articleItems.parseAdditionalInput(
                  additional.parseType,
                  document.querySelector(additional.id).value,
                );
            },
            false,
          );
        }
      },

      /**
       * @description Adding edit and remove icons
       * @param {any} params
       * @returns void
       */
      listTools: (params) => {
        globalArticleNumber = params.articleNr;

        // Edit icon with event listerner
        const editToolCell = params.tableRow.insertCell(-1);
        editToolCell.className = 'center-text review-hidden';

        const editIcon = document.createElement('i');
        const editIconElement = editToolCell.appendChild(editIcon);

        editIconElement.className = 'fa fa-edit fpa-edit-item';
        editIconElement.setAttribute('id', `editItem_${params.articleNr}`);

        document.getElementById(`editItem_${params.articleNr}`).addEventListener('click', () => {
          fixedPriceAgreement.articleItems.editItem(params.articleNr);
        });

        // Edit icon with event listerner
        const deleteToolCell = params.tableRow.insertCell(-1);
        deleteToolCell.className = 'center-text  review-hidden';

        const deleteIcon = document.createElement('i');
        const deleteIconElement = deleteToolCell.appendChild(deleteIcon);

        deleteIconElement.className = 'fa fa-trash fpa-remove-item';
        deleteIconElement.setAttribute('id', `deleteItem_${params.articleNr}`);
        document.getElementById(`deleteItem_${params.articleNr}`).addEventListener('click', () => {
          fixedPriceAgreement.articleItems.removeItem(params.articleNr);
        });
      },

      /**
       * @description Trigger click event
       * To trick the form-control drop down element done in :-/ jQuery.
       * Todo: Remove jQuery....
       * @param {*} element
       * @param {*} event
       * @returns void
       */
      triggerEvent: (elementId, event) => {
        const triggerEvent = new Event(event); // Create the event
        document.querySelector(`#${elementId} a`).dispatchEvent(triggerEvent);
      }, // Dispatch the event.,

      /**
       * @description Edit Item
       * @param {String} articleNr
       * @returns void
       */
      editItem: (articleNr) => {
        globalArticleNumber = articleNr;

        fixedPriceAgreement.articleItems.triggerEvent(`getFixedPriceAgreementItem`, 'click');
        fixedPriceAgreement.articleItems.triggerEvent(`drp_${articleNr}`, 'click');

        fixedPriceAgreement.articleItems.handleStorage(articleNr, null, null);

        // Event listener edit
        document
          .getElementById('btnEditItem')
          .addEventListener('click', fixedPriceAgreement.articleItems.setEditedArticleItem);

        // Event listener cancel
        document.getElementById('btnEditItemCancel').addEventListener(
          'click',
          (event) => {
            fixedPriceAgreement.articleItems.changeFields({}, false);
          },
          false,
        );
      },

      /**
       * @description Set new Local storage from edit
       * @param {any} articleNr
       * @param {any} articleNrEdit
       * @returns {Object} storage
       */
      handleStorage: (articleNr, articleNrEdit, articleNrRemove) => {
        let newStorage = [];

        // Get previous storage and add  new item
        for (let storage of JSON.parse(fixedPriceAgreement.articleItems.getItem())) {
          let storageItems = {};
          let preItems = {
            customerPrice: storage.customerPrice,
            manualDiscount: storage.manualDiscount,
            termSupplement: storage.termSupplement,
            defaultPrice: storage.defaultPrice,
            CommitQuantity: storage.CommitQuantity,
            articleName: storage.articleName,
            articleNr: storage.articleNr,
          };

          // Populate fields
          if (preItems.articleNr === articleNr) {
            fixedPriceAgreement.articleItems.changeFields(preItems, true);
          }

          // Set new item from fields
          if (preItems.articleNr === articleNrEdit) {
            storageItems = {
              customerPrice: document.getElementById('customerPrice').value,
              manualDiscount: document.getElementById('manualDiscount').value,
              termSupplement: document.getElementById('termSupplement').value,
              defaultPrice: parseFloat(document.getElementById('defaultPrice').value).toFixed(2),
              CommitQuantity: document.getElementById('CommitQuantity').value,
              articleName: document
                .getElementsByClassName('getFixedPriceAgreementItem')[0]
                .getAttribute('data-designation'),
              articleNr: articleNrEdit,
            };
          } else {
            storageItems = preItems;
          }

          if (preItems.articleNr !== articleNrRemove) newStorage.push(storageItems);
        }

        return newStorage;
      },

      /**
       * @description Update list and store edited article
       * @param {string} articleNr
       * @returns void
       */
      setEditedArticleItem: () => {
        let articleNr = globalArticleNumber;

        if (!fixedPriceAgreement.preValidation()) {
          return false;
        }

        const form = fixedPriceAgreement.articleItems.collectFormData();

        // Set updated items to list
        for (let [key, value] of form.entries()) {
          if (document.getElementById(`item_${articleNr}_${key}`)) {
            document.getElementById(`item_${articleNr}_${key}`).innerText = value;
            document.getElementById(`item_${articleNr}`).classList.add('new-edit');
          }
        }

        const setNewStorage = fixedPriceAgreement.articleItems.handleStorage(null, articleNr, null);

        // Save to local storage
        localStorage.setItem('fixedPriceAgreement', JSON.stringify(setNewStorage));

        // Remove edit class
        fixedPriceAgreement.articleItems.removeCssClassOnElements('new-edit');

        // Cleanup the fields
        fixedPriceAgreement.articleItems.changeFields({}, false);

        // Clone items and create formelements for review
        fixedPriceAgreement.articleItems.review();
      },

      /**
       * @description Change fields and show/hide buttons
       * @param {*} storage
       * @param {*} type
       * @returns void
       */
      changeFields: (storage, type) => {
        document.getElementById('manualDiscount').value = type ? storage.manualDiscount : '';
        document.getElementById('termSupplement').value = type ? storage.termSupplement : '';
        document.getElementById('defaultPrice').value = type ? storage.defaultPrice : '';
        document.getElementById('CommitQuantity').value = type ? storage.CommitQuantity : '';
        document.getElementById('customerPrice').value = type ? storage.customerPrice : '';

        // Show and hide buttons
        fixedPriceAgreement.articleItems.buttonStates(type);

        // Reset Article dropdown when article been added to table
        for (let artItem of document.querySelectorAll('#getFixedPriceAgreementItem li')) {
          artItem.classList.remove('selected');
        }

        document.querySelector('#getFixedPriceAgreementItem .showcase a').innerText = 'Välj sort';
      },

      /**
       * @description Edit Button states
       * @param {*} type
       * @returns void
       */
      buttonStates: (type) => {
        type
          ? document.getElementById('btnAddItem').classList.add('hidden')
          : document.getElementById('btnAddItem').classList.remove('hidden');
        type
          ? document.getElementById('btnEditItem').classList.remove('hidden')
          : document.getElementById('btnEditItem').classList.add('hidden');
        type
          ? document.getElementById('btnEditItemCancel').classList.remove('hidden')
          : document.getElementById('btnEditItemCancel').classList.add('hidden');
      },

      /**
       * @description Review Agreement
       * @returns void
       */
      review: () => {
        // reviewArticleCategory && reviewArticleGroup
        document.getElementById('reviewArticleCategory').innerText =
          document.getElementById('ProductAreaItemId').value +
          ' - ' +
          document
            .getElementsByClassName('getFixedPriceAgreementCategories')[0]
            .getAttribute('data-designation');
        document.getElementById('reviewArticleGroup').innerText =
          document.getElementById('articleGroup').value +
          ' - ' +
          document
            .getElementsByClassName('getFixedPriceAgreementGroup')[0]
            .getAttribute('data-designation');

        // ArticleList
        fixedPriceAgreement.articleItems.reviewArticles();

        // Trigger Review of agreement period
        fixedPriceAgreement.articleItems.reviewDatePeriod();
      },

      /**
       * @description Review article list
       * @returns void
       */
      reviewArticles: () => {
        let clone = document.getElementById('myfixedPriceAgreements').cloneNode(true);

        document.getElementById('reviewArticleCollection').innerHTML = '';
        document.getElementById('reviewArticleCollection').appendChild(clone);

        let removeItems = document
          .getElementById('reviewArticleCollection')
          .getElementsByClassName('review-hidden');

        while (removeItems.length > 0) {
          let item = removeItems[0];
          item.parentNode.removeChild(item);
        }

        // Article input
        document.getElementById('AgreementsLines').value =
          fixedPriceAgreement.articleItems.getItem();
      },

      /**
       * @description Review the agreement period
       * @returns void
       */
      reviewDatePeriod: () => {
        const toTadeBasedOnSelection = document
          .querySelector('.product-group-date-style-picker')
          .classList.contains('hidden')
          ? 'fixedPriceAgreementToDate'
          : 'fixedPriceAgreementToDatePicker';

        let fromDate = new Date(document.getElementById('fixedPriceAgreementFromDate').value);
        let toDate = document.getElementById(toTadeBasedOnSelection).value;

        if (fromDate && toDate) {
          let startperiod = fromDate.toLocaleDateString('sv-SE');
          let endperiod;

          if (
            document.querySelector('.product-group-date-style-picker').classList.contains('hidden')
          ) {
            endperiod = new Date(
              fromDate.setMonth(fromDate.getMonth() + parseInt(toDate)),
            ).toLocaleDateString('sv-SE');
          } else {
            let formatDate = new Date(toDate);
            endperiod = formatDate.toLocaleDateString('sv-SE');
          }

          // Show dates and add Date to input.
          document.getElementById('reviewAgrementPeriod').innerHTML =
            `${startperiod} - ${endperiod}`;
          document.getElementById('fixedPriceAgreementGeneratedEndDate').value = endperiod;
        }
      },

      /**
       * @description Remove item by id in storage
       * @param {string} articleNr
       * @returns void
       */
      removeItem: (articleNr) => {
        document.getElementById(`item_${articleNr}`).classList.add('new-remove');

        const removeFromStorage = fixedPriceAgreement.articleItems.handleStorage(
          null,
          null,
          articleNr,
        );
        localStorage.setItem('fixedPriceAgreement', JSON.stringify(removeFromStorage));

        if (JSON.parse(fixedPriceAgreement.articleItems.getItem()).length < 1) {
          document.getElementById('btnAddItem').classList.add('disabled');
          document.getElementById('fixedPricebtnGotoReceiverForm').classList.add('hidden');
        }

        setTimeout(function () {
          document.getElementById(`item_${articleNr}`).remove();

          if (document.querySelector('#myfixedPriceAgreements tbody').rows.length < 1) {
            document.querySelector('.additionalTexts').classList.add('hidden');
          }

          // Clone items and create form elements for review
          fixedPriceAgreement.articleItems.review();
        }, 1500);
      },

      /**
       * @description Remove CSS classes on all elements with specific css class
       * @param {string} cssClass
       * @returns void
       */
      removeCssClassOnElements: (cssClass) => {
        // Remove edit css class
        setTimeout(function () {
          const listElements = document.getElementsByClassName(cssClass);
          for (let int = 0; int < listElements.length; int++) {
            listElements[int].classList.remove(cssClass);
          }
        }, 2000);
      },
    },
  };

  fixedPriceAgreement.init();

  /* ------------------------------------------------------------------------- */

  function bindEvents() {
    $getFixedPriceAgreementCategories.change(
      fixedPriceAgreement.onFixedPriceAgreementCategoryChange,
    );
    $getFixedPriceAgreementGroup.change(fixedPriceAgreement.onFixedPriceAgreementGroupChange);
    $getFixedPriceAgreementItem.change(fixedPriceAgreement.onFixedPriceAgreementArticleChange);
    $btnAddItemToLocalStorage.click(fixedPriceAgreement.articleItems.addItem);

    $btnSubmit.click(onSubmit);
    $btnBackToAgreementForm.click(onBackToAgreementForm);
    $btnBackToReceiverForm.click(onBackToReceiverForm);
    $btnReview.click(onReview);
    $btnGotoReceiverForm.click(gotoReceiverForm);
    $dropdownProducts.change(onProductChange);
    $dropdownGrainType.change(onGrainTypeChange);
    $dropdownPeriod.change(onPeriodChange);
    $dropdownAgreement.change(onAgreementChange);
    $dropdownAgreementType.change(onAgreementTypeChange);
    $dropdownSeedAgreement.change(onSeedAgreementChange);
    $radioWatchType.change(onWatchTypeChange);
    $checkboxTermsAccepted.change(onTermsAcceptedChange);
    $checkboxCreateReserveAgreement.change(onCreateReserveAgreementChange);
    $dropdownReceivers.change(onReceiverChange);

    // Removing on Request - keyup events that prevent number field to auto adjust value if user add minus
    //#30319, E-signing feed | Entering a negative value for Termin supply
    //$termSupplement.keyup(integerChange);
    //$manualDiscount.keyup(integerChange);
    $quantity.keyup(integerChange);
  }

  /***
   * @description check on Seedagreement if user selected a period as "Beredskapodling"
   * @returns void
   */
  let agreementPeriodObserver = null;
  const agreementPreparednessSelection = () => {
    if (document.querySelector('.js-seed-agreement-form')) {
      const agreementPeriodInput = document.getElementById('AgreementPeriod');

      if (agreementPeriodInput) {
        if (agreementPeriodObserver) {
          agreementPeriodObserver.disconnect();
        }

        agreementPeriodObserver = new MutationObserver(() => {
          const regex = /^Beredskapsodling;/;
          if (regex.test(agreementPeriodInput.getAttribute('value'))) {
            document.querySelector('#CreateReserveAgreement').disabled = true;
          } else {
            document.querySelector('#CreateReserveAgreement').disabled = false;
          }
        });

        agreementPeriodObserver.observe(agreementPeriodInput, {
          attributes: true,
          attributeFilter: ['value'],
        });
      }
    }
  };

  bindEvents();
  setupValidation();
  initPriceWatchEndDate();
  comboBoxLoader.initBottomLinearLoader();
  initFixedAgreementDate();
  fixedPriceAgreementToDatePicker();
  agreementPreparednessSelection();

  function isRequiredForSportAndForwardAvtal() {
    // SportAndForwardAvtal
    if (
      agreementType === 'SportAndForwardAvtal' &&
      (!isInternalPage || $('#WatchPrice').is(':checked'))
    ) {
      return true;
    }

    // PrissakringDepaavtal
    if (!isInternalPage && isSecureDepaAgreement()) {
      return true;
    }

    return false;
  }

  function setupValidation() {
    var lowPrice = GroCommon.parseInt($('#PriceLow').val()) || 500;
    var maxPrice = GroCommon.parseInt($('#PriceHigh').val()) || Number.MAX_SAFE_INTEGER;

    var lowPriceErrorMessage =
      'Priset kan inte vara under ' + lowPrice + ' kr. Pris anges i kr/ton';
    var maxPriceErrorMessage = 'Priset kan inte vara över ' + maxPrice + ' kr. Pris anges i kr/ton';

    var minMaxQuantity = getMinMaxCommitQuantityValues('#CommitQuantityMin', '#CommitQuantityMax');

    if ($().validate) {
      var agreementType = $('#AgreementType').val();

      $form.validate({
        ignore: [],
        errorElementClass: 'error',
        errorClass: 'error-item',
        errorElement: 'span',
        onkeyup: false,

        rules: {
          AgreementAvtal: {
            required: function () {
              return isSecureDepaAgreement() || agreementType === 'PrissakringUtsadesavtal';
            },
          },
          AgreementType: {
            required: function () {
              return agreementType === 'PrissakringUtsadesavtal';
            },
          },
          ProductItemId: {
            required: true,
          },
          GrainType: {
            required: true,
          },
          CommitQuantity: {
            required: true,
            digits: true,
            min: minMaxQuantity.minQuantity,
            max: minMaxQuantity.maxQuantity,

            agreementQuantity: function () {
              return agreementType === 'PrissakringUtsadesavtal';
            },
          },
          ReserveQuantity: {
            required: function () {
              return $checkboxCreateReserveAgreement.is(':checked');
            },
            digits: true,
            min: minMaxQuantity.minQuantity,
          },
          DeliveryMode: {
            required: true,
          },
          Warehouse: {
            required: true,
          },
          AgreementPeriod: {
            required: true,
          },
          WatchType: {
            required: function () {
              return isSportAndForwardAgreement();
            },
          },
          Price: {
            required: function () {
              return (
                (isSportAndForwardAgreement() && $('#SecurePrice').is(':checked')) ||
                (isSecureDepaAgreement() && isInternalPage) ||
                (agreementType === 'PrissakringUtsadesavtal' && !$('.price-row').hasClass('hidden'))
              );
            },
            digits: true,
            min: lowPrice,
            max: maxPrice,
          },
          UpperPrice: {
            required: function () {
              return isRequiredForSportAndForwardAvtal();
            },
            digits: true,
            min: lowPrice,
            max: maxPrice,
          },
          LowerPrice: {
            required: function () {
              return isRequiredForSportAndForwardAvtal();
            },
            digits: true,
            lowerPriceMustLessUpperPrice: true,
            min: lowPrice,
            max: maxPrice,
          },
          PriceWatchEndDate: {
            date: true,
            exact_date: true,
            agreementDateMin: true,
            agreementDateMax: true,
            required: function () {
              return isRequiredForSportAndForwardAvtal();
            },
          },
          TargetAction: {
            required: function () {
              return isRequiredForSportAndForwardAvtal();
            },
          },
          approveAgreementTerm: {
            required: function () {
              return isRequiredForSportAndForwardAvtal();
            },
          },
          ReceiverEmail: {
            required: function () {
              return !$btnReview.hasClass('disabled');
            },
            validateReceiverEmail: true,
          },
          ReceiverPersonalNumber: {
            required: function () {
              return !$btnReview.hasClass('disabled');
            },
            validateReceiverPersonalNumber: true,
          },
          ReceiverMobilePhoneNumber: {
            required: false,
            validateReceiverMobilePhoneNumber: true,
          },
          Area: {
            required: function (element) {
              return $('#AgreementType').val() === 'Fröavtal';
            },
            digits: true,
            min: 0,
          },
          manualDiscount: {
            digits: true,
            min: () => {
              if (!specialAppliedRulesForPigPull) {
                return 0;
              } else {
                return -9999999999999;
              }
            },
            max: () => {
              if (!specialAppliedRulesForPigPull) {
                return 30;
              } else {
                return 9999999999999;
              }
            },
          },
        },
        messages: {
          AgreementAvtal: {
            required: 'Välj avtal',
          },
          AgreementType: {
            required: 'Välj avtalstyp',
          },
          CommitQuantity: {
            required: 'Kvantitet ton måste anges',
            digits: 'Kvantitet ton anges numeriskt',
            min:
              'Kvantiteten måste vara mellan ' +
              minMaxQuantity.minQuantity +
              ' och ' +
              minMaxQuantity.maxQuantity,
            max:
              'Kvantiteten måste vara mellan ' +
              minMaxQuantity.minQuantity +
              ' och ' +
              minMaxQuantity.maxQuantity,
          },
          ReserveQuantity: {
            required: 'Kvantitet ton måste anges',
            digits: 'Kvantitet ton anges numeriskt',
            min: 'Du kan inte ange kvantitet som är mindre än ' + minMaxQuantity.minQuantity,
          },
          DeliveryMode: {
            required: 'Leveranssätt måste väljas',
          },
          Warehouse: {
            required: 'Mottagningsplats måste väljas',
          },
          ProductItemId: {
            required: 'Gröda måste väljas',
          },
          GrainType: {
            required: 'Sort måste väljas',
          },
          WatchType: {
            required: 'Välj typ',
          },
          Price: {
            required: 'Pris måste anges',
            digits: 'Ange endast siffror',
            min: !(isSecureDepaAgreement() && !isInternalPage) && lowPriceErrorMessage,
            max: maxPriceErrorMessage,
          },
          UpperPrice: {
            required: 'Övre pris måste anges',
            digits: 'Ange endast siffror',
            atLeastOnePriceMustBeInput: 'Något pris kanske ska anges?',
            min: lowPriceErrorMessage,
            max: maxPriceErrorMessage,
          },
          LowerPrice: {
            required: 'Undre pris måste anges',
            digits: 'Ange endast siffror',
            lowerPriceMustLessUpperPrice: 'Undre pris måste vara lägre än Övre pris',
            optinalLowerPriceMustBeGreatMinValue:
              'Undre pris understiger ' + lowPrice + ' kr. Pris anges i kr/ton.',
            min: lowPriceErrorMessage,
            max: maxPriceErrorMessage,
          },
          PriceWatchEndDate: {
            required: 'Var vänlig ange ett giltigt datum',
            date: 'Var vänlig ange ett giltigt datum',
          },
          TargetAction: {
            required: 'Du måste ange Resultat av prisbevakning',
          },
          AgreementPeriod: {
            required: function () {
              return $('.periodDropdown').hasClass('validityperiod')
                ? 'Giltighetsperiod måste väljas'
                : 'Leveransperiod måste väljas';
            },
          },
          ReceiverEmail: {
            required: window.validationMessage.email.required,
            validateReceiverEmail: window.validationMessage.email.valid,
          },
          ReceiverPersonalNumber: {
            required: window.validationMessage.personNumber.required,
            validateReceiverPersonalNumber:
              window.validationMessage.personNumber.purchasingagreementssnvalid,
          },
          ReceiverMobilePhoneNumber: {
            required: window.validationMessage.mobileSE.required,
            validateReceiverMobilePhoneNumber: window.validationMessage.mobileSE.valid,
          },
          Area: {
            required: 'Området måste anges',
            digits: 'Ange endast siffror',
            min: 'Området kan inte vara mindre än 0 ',
          },
        },
        highlight: function (element, errorClass, validClass) {
          $('li#p_' + $(element).attr('name')).show();
          var errors = $('ul.errors-list li').filter(function () {
            return $(this).css('display') === 'list-item';
          }).length;
          if (errors >= 3) {
            $('ul.errors-list').show();
          }
          $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
          $('li#p_' + $(element).attr('name')).hide();
          var errors = $('ul.errors-list li').filter(function () {
            return $(this).css('display') === 'list-item';
          }).length;
          if ($('ul.errors-list').find('li[id^="p"]').is(':visible') === false || errors < 3) {
            $('ul.errors-list').hide();
          }
        },
        errorPlacement: function (error, element) {
          var typeElement = $(element).attr('type');
          if (typeElement === 'radio') {
            element.parent('div.lm__radio').parent().before(error);
          } else {
            element.after(error);
          }
        },
      });
    }
  }

  /**
   * Setting the Validation for Fixed Price Agreement.
   * @param {any} element
   */
  function setFixedPriceAgreementDateValidation(element) {
    if (agreementType !== 'FastPrisAvtalFoder') return false;
    if (specialAppliedRulesForPigPull) return false;

    $(element).rules('remove');
    $(element).rules('add', {
      date: true,
      exact_date: true,
      agreementDateMin: true,
      MaxFixedPriceEndDate: true,
      required: true,
      messages: {
        required: 'Du måste ange i ett startdatum',
        date: 'Du måste ange ett startdatum',
        agreementDateMin: 'Startdatum kan inte börja den valda dagen',
        MaxFixedPriceEndDate: 'Datumet kan inte sluta på vald dag',
      },
    });

    return $(formSelector).validate().element(element);
  }

  /**
   * Manual discount - Min o max validation from input attributes
   */
  function validateInputFromSelector(element) {
    let validationAccept = ['FastPrisAvtalFoder', 'PrissakringUtsadesavtal'];

    if (specialAppliedRulesForPigPull) return false;
    if (!validationAccept.includes(agreementType)) return false;

    let message = `Du har angett ett otillåtet värde. Tillåtna värden sträcker sig mellan:
			  ${$(element).attr('min')} och ${$(element).attr('max')} `;

    $(element).rules('remove');
    $(element).rules('add', {
      max: parseInt($(element).attr('max')),
      min: parseInt($(element).attr('min')),
      number: true,
      messages: {
        number: 'Du måste ange siffror',
        min: message,
        max: message,
      },
    });

    return $(formSelector).validate().element(element);
  }

  $('#CommitQuantity').on('keyup', function () {
    validateInputFromSelector($(this));
    fixedPriceAgreement.preValidation();
  });

  $('#termSupplement').on('blur', function () {
    if (specialAppliedRulesForPigPull) {
      return;
    }

    validateInputFromSelector($(this));
    fixedPriceAgreement.preValidation();
  });

  $('#manualDiscount').on('blur', function () {
    validateInputFromSelector($(this));
    fixedPriceAgreement.preValidation();
  });

  /**
   * Fixed Price agreement Agreement Date picker.
   * */
  function initFixedAgreementDate() {
    if (agreementType !== 'FastPrisAvtalFoder') return false;
    if ($.fn.datepicker) {
      $('#fixedPriceAgreementFromDate')
        .datepicker({
          defaultDate: '0',
          onSelect: function (newText) {
            setFixedPriceAgreementDateValidation($(this));
          },
          monthNames: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December',
          ],
          dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
          numberOfMonths: 1,
          minDate: '0',
          maxDate: '+1y',
          firstDay: 1,
          showOtherMonths: true,
          selectOtherMonths: true,
          dateFormat: 'yy-mm-dd',
          beforeShow: function () {
            setTimeout(function () {
              $('#fixedPriceAgreementFromDate').css('z-index', 5);
            }, 0);
          },
        })
        .on('blur', function () {
          setFixedPriceAgreementDateValidation($(this));
        });
    }
  }

  /**
   * Fixed Price agreement Agreement Date picker - For pul and pigg.
   * */
  function fixedPriceAgreementToDatePicker() {
    if (agreementType !== 'FastPrisAvtalFoder') return false;
    if ($.fn.datepicker) {
      $('#fixedPriceAgreementToDatePicker').datepicker({
        defaultDate: '0',
        monthNames: [
          'Januari',
          'Februari',
          'Mars',
          'April',
          'Maj',
          'Juni',
          'Juli',
          'Augusti',
          'September',
          'Oktober',
          'November',
          'December',
        ],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        numberOfMonths: 1,
        minDate: '0',
        maxDate: '+1y',
        firstDay: 1,
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat: 'yy-mm-dd',
        beforeShow: function () {
          setTimeout(function () {
            $('#fixedPriceAgreementToDatePicker').css('z-index', 5);
          }, 0);
        },
      });
    }
  }

  function initPriceWatchEndDate() {
    if ($.fn.datepicker) {
      $('#PriceWatchEndDate')
        .datepicker({
          defaultDate: new Date(),
          onSelect: function (newText) {
            // compare the new value to the previous one
            if ($(this).data('previous') !== newText) {
              $(formSelector).validate().element('#PriceWatchEndDate');
            }
          },
          monthNames: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December',
          ],
          dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
          firstDay: 1,
          showOtherMonths: true,
          selectOtherMonths: true,
          dateFormat: 'yy-mm-dd',
          beforeShow: function () {
            setTimeout(function () {
              $('.ui-datepicker').css('z-index', 5);
            }, 0);
          },
        })
        .on('change', function () {
          $(formSelector).validate().element('#PriceWatchEndDate');
        });
    }
  }

  function isSeedAgreement() {
    return agreementType == 'Utsadesavtal';
  }
  function isForageSeedAgreement() {
    return agreementType == 'Fröavtal';
  }
  function isPriceProtectSeedAgreement() {
    return agreementType == 'PrissakringUtsadesavtal';
  }
  function isDepaAgreement() {
    return agreementType == 'Depaavtal' || isSecureDepaAgreement();
  }

  /**
   * Check if agreement type is 'PrissakringDepaavtal'
   */
  function isSecureDepaAgreement() {
    return agreementType === 'PrissakringDepaavtal';
  }

  /**
   * Check if agreement type is 'SportAndForwardAvtal'
   */
  function isSportAndForwardAgreement() {
    return agreementType === 'SportAndForwardAvtal';
  }

  function onProductChange(event, selectedItem) {
    var productItemId = selectedItem.data;
    $('#product-item-name').html(selectedItem.dataText);

    purchasingAgreementService
      .getGrainTypes(agreementType, priceAreaId, productItemId)
      .done(function (data) {
        var options = $.map(data, function (item) {
          if (!isSeedAgreement() && !isForageSeedAgreement()) {
            return { value: item.GrainName, display: item.GrainDescription };
          }
          return {
            value: item.ProductItemId,
            display: `${item.ProductItemName} - ${item.ProductItemId}`,
          };
        });

        renderDropdown($dropdownGrainType, options, 'Välj sort', onGrainTypeChange);
      });
  }

  function onGrainTypeChange(event, selectedItem) {
    var $this = $(this);
    $('#grain-type').html(selectedItem.dataText);

    if (isSportAndForwardAgreement()) {
      var productItemId = $dropdownProducts.find('input').val();
      var grainTypeId = selectedItem.data;

      purchasingAgreementService
        .getSpotAndForwarPriceListForGrainType(priceAreaId, productItemId, grainTypeId)
        .done(function (data) {
          var options = $.map(data, function (item) {
            return {
              value: item.PriceTypeId + ';' + item.PricePeriod,
              display: item.DisplayLabel,
              data: { price: isInternalPage ? item.Price : '' },
            };
          });
          $btnGotoReceiverForm.removeClass('disabled');
          renderDropdown($dropdownPeriod, options, 'Välj leveransperiod');
        });
    } else {
      $('.div-DeliveryMode').removeClass('disabled');
      $('.div-Warehouse').removeClass('disabled');
      $('#CommitQuantity').parents('.agreement-element').removeClass('disabled');
      $('#Area').parents('.agreement-element').removeClass('disabled');
      $('.div-reserve-agreement').parents('.agreement-element').removeClass('disabled');
      $dropdownPeriod.parents('.agreement-element').removeClass('disabled');
      if (isSeedAgreement)
        $checkboxCreateReserveAgreement.parents('.agreement-element').removeClass('disabled');
      $btnGotoReceiverForm.removeClass('disabled');
    }
  }

  function onPeriodChange(event, selectedItem) {
    // Spot+Protect only?
    $('#period-detail').html(selectedItem.dataText);

    if (isInternalPage) {
      var price = $('.periodDropdown .dropdown .selected').attr('data-price');
      $('#price-detail').html(price);
      $('.js-Price').val(price);
    }

    if ($('#AgreementPeriod').val() !== '') {
      $('.agreement-detail').removeClass('hidden');
    }
  }

  function onAgreementChange(event, selectedItem) {
    var $selectedItem = $(this).find('.dropdown li.selected > a');
    var agreementId = $selectedItem.attr('data-agreementid');
    var productItemId = $selectedItem.attr('data-productItemId');
    var priceAreaId = $selectedItem.attr('data-priceAreaId');
    var grainType = $selectedItem.attr('data-grainType');
    var grainDescription = $selectedItem.attr('data-grainDescription');
    var productItemName = $selectedItem.attr('data-productItemName');
    selectedItem.pricePeriod = $selectedItem.attr('data-pricePeriod');
    $('#period-detail').html('');
    $('#AgreementId').val(agreementId);
    $('#product-item-name').html(productItemName);
    $('#grain-type').html(grainDescription);

    purchasingAgreementService
      .getProtectAgreement(agreementId, productItemId, priceAreaId, grainType, productItemName)
      .done(function (data) {
        var options = $.map(data, function (item) {
          return {
            priceTypeId: item.PriceTypeId,
            value: item.PriceTypeId + ';' + item.PricePeriod,
            display: item.DisplayLabel,
            data: { price: isInternalPage ? item.Price : '' },
          };
        });

        renderDropdown($dropdownPeriod, options, 'Välj leveransperiod');

        if (data.length > 0) {
          $('#period-detail').html(options[0].display);
          $('#AgreementPeriod').val(options[0].priceTypeId + ';' + selectedItem.pricePeriod);
          var price = options[0].data.price;
          $('#price-detail').html(price);
          $('.js-Price').val(price);
          $('#price-periods').find('.error-item').addClass('hidden');
          $('#price-periods').removeClass('disabled');
          $('#price-periods').parents('.agreement-element').removeClass('disabled');
          $btnGotoReceiverForm.removeClass('disabled');
        } else {
          $('#price-periods').find('.error-item').removeClass('hidden');
          $('#price-periods').addClass('disabled');
        }
      });

    $('#area-sort-overview').removeClass('hidden');
  }
  function onAgreementTypeChange(event, selectedItem) {
    $('#TargetAction').val(selectedItem.data);
    $('#agreement-type').html(selectedItem.dataText);
    $('.price-row').addClass('hidden');
    if (!selectedItem.data.startsWith('Pool')) {
      $('#price-periods').find('.error-item').addClass('hidden');
      $('#price-periods').removeClass('disabled');
      $('#price-periods').parents('.agreement-element').removeClass('disabled');
      $('#Price').parents('.agreement-element').removeClass('disabled');
      $('.price-row').removeClass('hidden');
    }
    $('#CommitQuantity').parents('.agreement-element').removeClass('disabled');
    $btnGotoReceiverForm.removeClass('disabled');
    $('#area-sort-overview').removeClass('hidden');
  }
  function onSeedAgreementChange(event, selectedItem) {
    var $selectedItem = $(this).find('.dropdown li.selected > a');
    var isReserveAgreement = GroCommon.parseBool($selectedItem.attr('data-isreserveagreement'));
    var reserveAgreementTypes = [];
    var agreementTypes = [];

    reserveAgreementTypes.push(
      {
        value: 'PoolavtalReserve',
        display: 'Poolavtal reserv',
        data: { key: 'agreementType', value: 'Poolavtal' },
      },
      {
        value: 'TerminsavtalReserve',
        display: 'Terminsavtal reserv',
        data: { key: 'agreementType', value: 'Terminsavtal' },
      },
    );
    agreementTypes.push(
      {
        value: 'Poolavtal',
        display: 'Poolavtal',
        data: { key: 'agreementType', value: 'Poolavtal' },
      },
      {
        value: 'Terminsavtal',
        display: 'Terminsavtal',
        data: { key: 'agreementType', value: 'Terminsavtal' },
      },
    );
    var options = isReserveAgreement ? reserveAgreementTypes : agreementTypes;
    $dropdownAgreementType.parents('.agreement-element').removeClass('disabled');
    renderDropdown($dropdownAgreementType, options, 'Välj avtalstyp', onAgreementTypeChange);

    var agreementId = $selectedItem.attr('data-agreementid');
    var selectedAgreementName = $selectedItem.attr('data-agreementname');
    var productItemId = $selectedItem.attr('data-productItemId');
    var productItemName = $selectedItem.attr('data-productItemName');
    var warehouseId = $selectedItem.attr('data-warehouseId');
    var pricePeriod = $selectedItem.attr('data-pricePeriod');
    var pricePeriodDisplayLabel = $selectedItem.attr('data-displayLabel');
    var validityPeriod = $selectedItem.attr('data-validityperiod');
    var harvestYear = $selectedItem.attr('data-harvestyear');
    var quantity = GroCommon.parseInt($selectedItem.attr('data-quantity'));

    if (agreementType === 'PrissakringUtsadesavtal') {
      $('#CommitQuantity').attr('min', 0);
      $('#CommitQuantity').attr('max', quantity);
    }

    $('#CommitQuantity').val(quantity);
    $('#CommitQuantityMin').val(0);
    $('#CommitQuantityMax').val(quantity);
    $('#IsReserveAgreement').val(isReserveAgreement);
    $('#AgreementId').val(agreementId);
    $('#agreement-quantity').html(quantity);
    $('#product-item-name').html(productItemName);
    $('#period-detail').html(pricePeriodDisplayLabel);
    $('#AgreementPeriod').val('Seed' + ';' + pricePeriod);
    $('#SelectedAgreementName').html(selectedAgreementName);
    $('#ProductItemId').val(productItemId);
    $('#GrainType').val(productItemId);
    $('#Warehouse').val(warehouseId);
    $('#ValidityPeriod').val(validityPeriod);
    $('#HarvestYear').val(harvestYear);
  }
  function onWatchTypeChange(event) {
    var container = $('div[data-secure-price]');
    var status = $(this).attr('id') == 'SecurePrice' ? 'on' : 'off';
    container.attr('data-secure-price', status);
    if (status == 'on') {
      var currentPrice = $('#price-detail').html();
      $('.js-Price').val(currentPrice);
      $('.js-Price').parent('.agreement-element').removeClass('disabled');
    } else {
      $('.js-Price').val('');
    }
  }

  function onTermsAcceptedChange(event) {
    if ($(this).is(':checked')) {
      $btnSubmit.removeClass('disabled');
    } else {
      $btnSubmit.addClass('disabled');
    }
  }
  function onCreateReserveAgreementChange(event) {
    if ($(this).is(':checked')) {
      $('.div-resever-agreement-quantity').removeClass('hidden');
      $('#ReserveQuantity').parents('.agreement-element').removeClass('disabled');
    } else {
      $('.div-resever-agreement-quantity').addClass('hidden');
      $('#ReserveQuantity').parents('.agreement-element').addClass('disabled');
    }
  }

  /**
   *
   * @param {string} errorMessage
   */
  function handleErrorResponse(resp) {
    let internalMessage = '';
    if (resp.responseJSON) {
      var errorMessages = Object.keys(resp?.responseJSON?.errors).map(function (key) {
        return resp.responseJSON.errors[key];
      });

      if (errorMessages.length > 0) {
        internalMessage = errorMessages.join('<br>');
      }
    } else {
      internalMessage =
        resp.Message && resp.Message.indexOf('Error-customerNbrMismatch') >= 0
          ? 'Kundnumret stämmer inte med nuvarande aktiva kund, ladda om sidan!'
          : 'Vänligen kontrollera om avtalet skapats i M3.';
    }

    var errorInstructions = isInternalPage ? internalMessage : 'Vänligen kontakta LM² supporten.';
    var $error = $('<div class="errorSaveAgreement errors-list">').html(
      '<p>Ett fel uppstod när avtalet skulle skapas. </p><p>' + errorInstructions + '</p>',
    );
    $btnSubmit.closest('.lm__block').prepend($error);
    $btnSubmit.prop('disabled', false).removeClass('disabled');
    $('.div-signing-loader').addClass('hidden');
  }

  function onSubmit(event) {
    event.preventDefault();

    $('.errorSaveAgreement').remove();
    $.merge($btnSubmit, $btnGotoReceiverForm, $btnBackToAgreementForm, $btnBackToReceiverForm)
      .prop('disabled', true)
      .addClass('disabled');
    $('.div-signing-loader').removeClass('hidden');
    var data = $form.serializeArray();

    // If it's internal site, we add current customer, to validate in backend
    if (isInternalPage) {
      var currentCustomerNumber = $('#currentCustomerNumber').attr('data-value');
      data.push({ name: 'CustomerNumber', value: currentCustomerNumber });
    }

    purchasingAgreementService
      .saveAgreement(data)
      .done(function (resp) {
        if (resp.Message && resp.Message.indexOf('Error') >= 0) {
          handleErrorResponse(resp);
        } else {
          var isSpotAndForwardPriceWatch =
            isSportAndForwardAgreement() &&
            (!isInternalPage || $('input[name="WatchType"]:checked').prop('id') === 'WatchPrice');
          trigger('save', {
            response: resp,
            agreement: data,
            isPriceWatch: isSpotAndForwardPriceWatch || isDepaAgreement(),
          });
        }
      })
      .error((resp) => {
        debugger;
        handleErrorResponse(resp);
      })
      .always(function () {
        setTimeout(function () {
          $.merge($btnGotoReceiverForm, $btnBackToAgreementForm, $btnBackToReceiverForm)
            .prop('disabled', false)
            .removeClass('disabled');
        }, 250);
      });
  }
  function onBackToAgreementForm(event) {
    $('.errorSaveAgreement').remove();
    stepsComponent.previous();
  }
  function onBackToReceiverForm(event) {
    $('.errorSaveAgreement').remove();
    if (isInternalPage && !isDepaAgreement() && $form.find('#Signer').val().length > 0) {
      $btnReview.removeClass('disabled');
    }
    stepsComponent.previous();
  }
  function isOtherReceiver() {
    return $('#ReceiverName').val() == 'Annan behörig mottagare';
  }
  function onReceiverChange(event, selectedItem) {
    $('.div-text-other-receiver-info').addClass('hidden');
    var $dropdownItem = $form.find('.receiverDropdown .dropdown .selected');
    $form.find('#Signer').val($dropdownItem.data('email'));
    $form.find('#ReceiverName').val($dropdownItem.data('name'));
    $form.find('#ReceiverEmail').val($dropdownItem.data('email'));
    $form.find('#Mobilephone').val($dropdownItem.data('mobilephonenumber'));
    $form.find('#ReceiverPersonalNumber').val($dropdownItem.data('personalnumber'));
    $('#ReceiverName').parents('.agreement-element').removeClass('disabled');
    $('#ReceiverEmail').parents('.agreement-element').removeClass('disabled');
    $('#ReceiverPersonalNumber').parents('.agreement-element').removeClass('disabled');
    $('#Mobilephone').parents('.agreement-element').removeClass('disabled');
    $btnReview.removeClass('disabled');

    /**
     * Hide or show personal number input field
     * Depends on selected receiver
     */
    var parentDiv = $form.find('#ReceiverPersonalNumber').parent('.agreement-element');

    if (
      $dropdownItem.data('personalnumber') === null ||
      $dropdownItem.data('personalnumber') === ''
    ) {
      parentDiv.find('#ReceiverPersonalNumber').attr('type', 'text');
      parentDiv.removeClass('hidden');
    } else {
      parentDiv.find('#ReceiverPersonalNumber').attr('type', 'hidden');
      parentDiv.addClass('hidden');
    }

    // Mask personal number
    maskPersonalNumber();

    if (isOtherReceiver()) {
      $('.div-text-other-receiver-info').removeClass('hidden');
    }
  }
  function validateDigitalSigningReceiverForm() {
    return (
      $(formSelector).validate().element('#ReceiverEmail') &&
      $(formSelector).validate().element('#Mobilephone') &&
      $(formSelector).validate().element('#ReceiverPersonalNumber')
    );
  }

  /**
   * Mask personal number
   */
  const maskPersonalNumber = () => {
    var maskedPersonalNumber = $('#ReceiverPersonalNumber')
      .val()
      .replace(/\d(?=(?:\D*\d){0,3}$)/g, '*');
    $('.review_receiver_personal_number').html(maskedPersonalNumber);
  };

  function onReview() {
    if (!$form.valid()) {
      return;
    }
    if (!isInternalPage || isDepaAgreement() || validateDigitalSigningReceiverForm()) {
      $('.review_Avtal').html(getDropdownDisplay($dropdownAgreement));
      $('.review_Groda').html(getDropdownDisplay($dropdownProducts));
      $('.review_Sort').html(getDropdownDisplay($dropdownGrainType));
      $('.review_Warehouse').html(getDropdownDisplay($dropdownWarehouses));
      $('.review_Period').html(
        getDropdownDisplay($dropdownPeriod) +
          ' ' +
          getHarvestYear($dropdownPeriod.find('input').val()),
      );
      $('.div-review-reserve-quantity').addClass('hidden');
      $('.review_UpperPrice').html($('#UpperPrice').val());
      $('.review_LowerPrice').html($('#LowerPrice').val());
      $('.review_Price').html($('#Price').val());
      $('.review_Quantity').html($('#CommitQuantity').val());
      $('.review_TransportType').html($('input[name="DeliveryMode"]:checked').prop('id'));
      $('.review_Prissakra').html($('input[name="TargetAction"]:checked').prop('id'));
      $('.review_AgreementDate').html($('#PriceWatchEndDate').val());
      var isSpotAndForwardPriceWatch =
        isSportAndForwardAgreement() &&
        (!isInternalPage || $('input[name="WatchType"]:checked').prop('id') === 'WatchPrice');
      var isProtectStoragePriceWatch = isSecureDepaAgreement() && !isInternalPage;
      if (isSpotAndForwardPriceWatch || isProtectStoragePriceWatch) {
        stepsComponent.setType('Prisbevakning');
      }
      if (isSecureDepaAgreement() || isPriceProtectSeedAgreement()) {
        $('.review_Price').html($('#price-detail').html());
        $('.review_Period').html($('#period-detail').html());
      }
      if (isForageSeedAgreement()) {
        $('.review_Area').html($('#Area').val());
        var isReserveAgreement = GroCommon.parseBool(
          $('input[name="IsReserveAgreement"]:checked').val(),
        );
        $('#IsReserveAgreement').val(isReserveAgreement);
        $('.review_reserve-agreement').html(isReserveAgreement ? 'Ja' : 'Nej');
      }
      if (isSeedAgreement()) {
        var createReserveAgreement = $checkboxCreateReserveAgreement.is(':checked');

        $('.review_create-reserve-agreement').html(createReserveAgreement ? 'Ja' : 'Nej');
        if (createReserveAgreement) {
          $('.review_reserve-quantity').html($('#ReserveQuantity').val());
          $('.div-review-reserve-quantity').removeClass('hidden');
        } else {
          $('.review_reserve-quantity').html('');
        }
      }
      if (isPriceProtectSeedAgreement()) {
        $('.review_Avtal').html($('#SelectedAgreementName').text());
        $('.review_Avtal_Type').html(getDropdownDisplay($dropdownAgreementType));
        $('.review-price-row').addClass('hidden');
        if (!$('.review_Avtal_Type').html().startsWith('Pool')) {
          $('.review-price-row').removeClass('hidden');
        }
      }
      if (isInternalPage && !isDepaAgreement()) {
        if (isOtherReceiver()) {
          $('#ReceiverName').val($('#ReceiverEmail').val());
        }
        $('.div-review-receiver_mobile_phone_number').addClass('hidden');
        $('.review_receiver_name').html($('#ReceiverName').val());

        // Mask personal number
        maskPersonalNumber();

        $('.review_receiver_email').html($('#ReceiverEmail').val());
        if ($('#Mobilephone').val().length > 0) {
          $('.review_receiver_mobile_phone_number').html($('#Mobilephone').val());
          $('.div-review-receiver_mobile_phone_number').removeClass('hidden');
        }
      }
      stepsComponent.next();
    }
  }
  function gotoReceiverForm() {
    if ($form.valid()) {
      if (!isDepaAgreement() && isInternalPage) {
        if ($form.find('#Signer').val().length == 0) {
          purchasingAgreementService.getReceiversForDigitalSigning().done(function (data) {
            $.each(data, function (index, item) {
              var role = item.RoleProfileName;
              var displayField = item.Name;
              if (role && role.length > 0) {
                displayField = role + ' (' + displayField + ')';
              }

              $dropdownReceivers
                .find('.dropdown')
                .append(
                  '<li data-email="' +
                    item.Email +
                    '" data-name="' +
                    item.Name +
                    '" data-mobilePhoneNumber="' +
                    item.MobilePhoneNumber +
                    '" data-personalNumber="' +
                    item.PersonalNumber +
                    '"><a href="javascript:void(0)">' +
                    displayField +
                    '</a></li>',
                );
            });
            setDropdown($dropdownReceivers, 'type-3');
            $dropdownReceivers.parents('.agreement-element').removeClass('disabled');
            $('.div-receiver-loader').addClass('hidden');
          });
        } else {
          $btnReview.removeClass('disabled');
          $('.div-receiver-loader').addClass('hidden');
        }
        stepsComponent.next();
      } else {
        onReview();
      }
    } else {
      var validator = $form.validate();
      $.each(validator.errorMap, function (index, value) {});
    }
  }
  function renderDropdown($dropdown, options, placeholder) {
    $dropdown.find('.dropdown').html('');
    $dropdown.find(' > .showcase > a').html(placeholder);
    $dropdown.find('input[type="hidden"]').val('');

    if (options.length > 0) {
      var $options = $.map(options, function (option) {
        var $li = $(
          '<li data-value="' +
            option.value +
            '"><a href="javascript:void(0)">' +
            option.display +
            '</a></li>',
        );
        if (option.data) {
          $.each(option.data, function (key, value) {
            $li.attr('data-' + key, value);
          });
        }

        return $li;
      });
      $dropdown.find('.dropdown').append($options);

      setDropdown($dropdown, 'type-3');
      $dropdown.parents('.agreement-element').removeClass('disabled');
    }
  }

  function getDropdownDisplay($dropdown) {
    return $dropdown.find(' > .showcase > a').html();
  }
  function getHarvestYear(periodInfo) {
    if (!periodInfo) {
      return '';
    }

    var startIndex = periodInfo.indexOf(';');
    var datePeriod = periodInfo.substring(startIndex + 1, startIndex + 9);
    var year = parseInt(datePeriod.substring(0, 4));
    var date = parseInt(datePeriod.substring(4));
    if (isNaN(year) || isNaN(date)) return '';

    return date < 701 ? year - 1 : year;
  }

  function trigger(callbackName, eventData) {
    if (callbacks[callbackName]) {
      $.each(callbacks[callbackName], function (index, callback) {
        callback.call(null, eventData);
      });
    }
  }

  this.on = function (callbackName, callback) {
    if (callbacks[callbackName]) {
      callbacks[callbackName].push(callback);
    }
  };
};

$(function createValidationRulesForPurchasingAgreements() {
  if ($.validator) {
    $.validator.addMethod(
      'exact_date',
      function (value, element) {
        var result = true;
        var dates = value.split('-');

        if (dates.length == 3) {
          var d = new Date(value);
          if (
            d.getFullYear() == dates[0] &&
            d.getMonth() == parseInt(dates[1]) - 1 &&
            d.getDate() == dates[2]
          ) {
            result = true;
          } else {
            result = false;
          }
        }

        return this.optional(element) || result;
      },
      'Var vänlig ange ett giltigt datum',
    );

    $.validator.addMethod(
      'lowerPriceMustLessUpperPrice',
      function (value, element) {
        //If false, the validation fails and the message below is displayed
        var upperPrice = parseInt($('#UpperPrice').val());
        var lowerPrice = parseInt($('#LowerPrice').val());
        return (
          this.optional(element) ||
          (!isNaN(upperPrice) && !isNaN(lowerPrice) && upperPrice >= lowerPrice)
        );
      },
      'Undre pris måste vara lägre än Övre pris',
    );

    $.validator.addMethod(
      'optinalLowerPriceMustBeGreatMinValue',
      function (value, element) {
        //If false, the validation fails and the message below is displayed
        var minValue = parseInt($('#PriceLow').val());
        var lowerPrice = parseInt($('#LowerPrice').val());
        if (isSecureDepaAgreement()) {
          return (
            this.optional(element) ||
            (!isNaN(minValue) && !isNaN(lowerPrice) && !(lowerPrice >= 0 && lowerPrice < minValue))
          );
        }
        return (
          this.optional(element) ||
          (!isNaN(minValue) && !isNaN(lowerPrice) && !(lowerPrice > 0 && lowerPrice < minValue))
        );
      },
      'Undre pris understiger. Pris anges i kr/ton',
    );

    $.validator.addMethod(
      'MaxFixedPriceEndDate',
      function (value, element) {
        //If false, the validation fails and the message below is displayed
        var maxDate = new Date();
        var enteredDate = Date.parse(element.value);
        enteredDate = new Date(enteredDate);
        maxDate.setFullYear(maxDate.getFullYear() + 1);

        return this.optional(element) || Number(enteredDate) <= Number(maxDate);
      },
      'Du kan inte ange datum som är längre fram än ett år från dagens datum',
    );

    $.validator.addMethod(
      'agreementDateMin',
      function (value, element) {
        //If false, the validation fails and the message below is displayed
        var minDate = new Date();
        var enteredDate = GroCommon.dateFromISO(element.value); //new Date(element.value);
        enteredDate.setHours(enteredDate.getHours() + 23);

        return this.optional(element) || enteredDate >= minDate;
      },
      'Du kan inte ange datum som är lägre än dagens datum',
    );

    $.validator.addMethod(
      'agreementDateMax',
      function (value, element) {
        //If false, the validation fails and the message below is displayed
        var maxDate = new Date();
        maxDate.setDate(new Date().getDate() + 60);
        var enteredDate = GroCommon.dateFromISO(element.value); //new Date(element.value);
        enteredDate.setHours(enteredDate.getHours() + 23);

        return this.optional(element) || enteredDate <= maxDate;
      },
      'Uppdraget får ej vara giltigt i mer än 60 dagar',
    );

    $.validator.addMethod(
      'validateReceiverEmail',
      function (email, element) {
        return (
          this.optional(element) ||
          $(element).parents('.agreement-element').hasClass('disabled') ||
          window.validation.email(email)
        );
      },
      window['validationMessage'].email.valid,
    );

    $.validator.addMethod(
      'validateReceiverPersonalNumber',
      function (personNumber, element) {
        return (
          this.optional(element) ||
          $(element).parents('.agreement-element').hasClass('disabled') ||
          window.validation.personNumber(personNumber)
        );
      },
      window['validationMessage'].email.valid,
    );

    $.validator.addMethod(
      'validateReceiverMobilePhoneNumber',
      function (receiverMobilePhoneNumber, element) {
        return (
          this.optional(element) ||
          $(element).parents('.agreement-element').hasClass('disabled') ||
          receiverMobilePhoneNumber.length == 0 ||
          window.validation.mobileSE(receiverMobilePhoneNumber)
        );
      },
      window.validationMessage.mobileSE.valid,
    );

    $.validator.addMethod('agreementQuantity', function (value, element) {
      var minMaxQuantity = getMinMaxCommitQuantityValues(
        '#CommitQuantityMin',
        '#CommitQuantityMax',
      );

      var quantity = GroCommon.parseInt($('#CommitQuantity').val());

      $.extend($.validator.messages, {
        agreementQuantity: $.validator.format(
          'Vänligen ange kvantitet mellan {0} och {1}',
          minMaxQuantity.minQuantity,
          minMaxQuantity.maxQuantity,
        ),
      });
      return (
        this.optional(element) ||
        (quantity >= minMaxQuantity.minQuantity && quantity <= minMaxQuantity.maxQuantity)
      );
    });
  }
});

/**
 *
 * @param {string} minQuantId
 * @param {string} maxQuantId
 * @returns
 */
var getMinMaxCommitQuantityValues = function (minQuantId, maxQuantId) {
  var minQuantity = minQuantId ? GroCommon.parseInt($(minQuantId).val()) : null;
  var maxQuantity = maxQuantId ? GroCommon.parseInt($(maxQuantId).val()) : null;

  if (!minQuantity || !maxQuantity) {
    minQuantity = 0;
    maxQuantity = Number.MAX_SAFE_INTEGER;
  }

  return { minQuantity: minQuantity, maxQuantity: maxQuantity };
};

var validatePriceAdjustmentFields = function (manualDiscount, termSupplement) {
  var form = $('#PurchasingAgreementForm');

  if (
    manualDiscount.value !== '' &&
    (manualDiscount.value > document.getElementById('manualDiscount').getAttribute('max') ||
      manualDiscount.value < document.getElementById('manualDiscount').getAttribute('min'))
  ) {
    form.validate().element('#manualDiscount');
    document.getElementById('btnAddItem').classList.add('disabled');
  }

  if (
    termSupplement.value !== '' &&
    (termSupplement.value > document.getElementById('termSupplement').getAttribute('max') ||
      termSupplement.value < document.getElementById('termSupplement').getAttribute('min'))
  ) {
    form.validate().element('#termSupplement');
    document.getElementById('btnAddItem').classList.add('disabled');
  }

  let manualDiscountElement = form.validate().element('#manualDiscount');
  let quantityElement = form.validate().element('#CommitQuantity');
  let termSupplementElement = form.validate().element('#termSupplement');
  if (manualDiscountElement && termSupplementElement && quantityElement) {
    document.getElementById('btnAddItem').classList.remove('disabled');
  }
};
